import { MessageDto } from '../../types';
import { MessageContent } from './MessageContent';
import { format } from 'date-fns';
import { ptBR } from 'date-fns/locale';
import { Bot, User, UserCog } from 'lucide-react';

interface MessageBubbleProps {
  message: MessageDto;
}

export function MessageBubble({ message }: MessageBubbleProps) {
  const isIncoming = message.direction === 'INCOMING';
  const role = message.role || 'contact'; // Default to contact if role is null

  // Determine colors and styling based on role
  const getRoleStyles = () => {
    switch (role) {
      case 'ai':
        return {
          bg: 'bg-sky-100 dark:bg-sky-900/60',
          border: 'border-sky-300 dark:border-sky-600',
          icon: <Bot className="h-4 w-4 text-sky-600 dark:text-sky-300" />,
          label: 'IA',
        };
      case 'attendant':
        return {
          bg: 'bg-emerald-100 dark:bg-emerald-900/60',
          border: 'border-emerald-300 dark:border-emerald-600',
          icon: <UserCog className="h-4 w-4 text-emerald-600 dark:text-emerald-300" />,
          label: 'Atendente',
        };
      default: // contact
        return {
          bg: 'bg-slate-50 dark:bg-slate-700/60',
          border: 'border-slate-200 dark:border-slate-500',
          icon: <User className="h-4 w-4 text-slate-500 dark:text-slate-300" />,
          label: 'Usuário',
        };
    }
  };

  const styles = getRoleStyles();
  const formattedTime = format(new Date(message.messageTimestamp), 'HH:mm', {
    locale: ptBR,
  });

  return (
    <div
      className={`flex ${isIncoming ? 'justify-start' : 'justify-end'} mb-4`}
    >
      <div className={`max-w-[85%] sm:max-w-[70%]`}>
        {/* Role indicator */}
        <div
          className={`flex items-center gap-1 mb-1 text-xs ${
            isIncoming ? 'justify-start' : 'justify-end'
          }`}
        >
          {styles.icon}
          <span className="text-muted-foreground">
            {message.senderName || styles.label}
          </span>
        </div>

        {/* Message bubble */}
        <div
          className={`rounded-lg border px-4 py-2 ${styles.bg} ${styles.border}`}
        >
          <MessageContent message={message} />

          {/* Timestamp */}
          <div
            className={`text-xs text-muted-foreground mt-1 ${
              isIncoming ? 'text-left' : 'text-right'
            }`}
          >
            {formattedTime}
          </div>
        </div>
      </div>
    </div>
  );
}
